export const ROOT = 'opportunity';

export const FETCH_OPPORTUNITY_REQUEST = `${ROOT}/FETCH_OPPORTUNITY_REQUEST`;
export const FETCH_OPPORTUNITY_FAILURE = `${ROOT}/FETCH_OPPORTUNITY_FAILURE`;
export const FETCH_OPPORTUNITY_SUCCESS = `${ROOT}/FETCH_OPPORTUNITY_SUCCESS`;

export const SET_OPPORTUNITY_MESSAGE = `${ROOT}/SET_OPPORTUNITY_MESSAGE`;
export const SET_OPPORTUNITY_SELECTED = `${ROOT}/SET_OPPORTUNITY_SELECTED`;

export const CLEAR_OPPORTUNITY_MESSAGE = `${ROOT}/CLEAR_OPPORTUNITY_MESSAGE`;
export const CLEAR_OPPORTUNITY_DATA = `${ROOT}/CLEAR_OPPORTUNITY_DATA`;
export const CLEAR_OPPORTUNITY_SELECTED = `${ROOT}/CLEAR_OPPORTUNITY_SELECTED`;